import { NEWS_REQUEST, NEWS_SUCCESS, NEWS_FAILURE,NEWS_DELETE } from '../Constants/ActionTypes';
 import { toast } from "react-toastify";
import * as API from '../API/api.js';

export const newsDetails = (values ,token)=> async dispatch => {
  try {
    dispatch({ type: NEWS_REQUEST });
    const data = await API.postNews(values,token);
    if (data) {
      dispatch({ type: NEWS_SUCCESS, payload: data });
        // navigate('/')
        toast("News Added Successfully")
    }
  } catch (error) {
    toast('DATA NOT DISPATCHED');
    dispatch({ type: NEWS_FAILURE });
  }
};

export const newsDelete = (values ,token)=> async dispatch => {
  try {
    dispatch({ type: NEWS_DELETE });
    const data = await API.deleteNews(values,token);
    console.log("Rqr Dta", values)
    if (data) {
      console.log(")00>" , data);
      dispatch({ type: NEWS_DELETE, payload: values });

        // navigate('/')
        toast("News Deleted Successfully")
        console.log("Final --> ",data);
    }
  } catch (error) {
    toast('News Not Deleted');
    dispatch({ type: NEWS_FAILURE });
  }
};

export const fetchNewsData = () => async dispatch => {
  try {
    dispatch({ type: NEWS_REQUEST });
    const {data} = await API.fetchNews();
    if (data) {
      dispatch({ type: NEWS_SUCCESS, payload: data });
    }
    else if(data.length === 0){
      console.log("no news");
    }
  } catch (error) {
    toast('ERROR IN FETCHING NEWS');
    console.log(error)
    dispatch({ type: NEWS_FAILURE });
  }
};


